import {
  IAppContext,
  IContentContext,
  INavLinkContext,
  IPanelContext,
} from 'component/layout/types';
import { createContext } from 'react';

export const AppLayoutContext = createContext<IAppContext>({});
export const ContentLayoutContext = createContext<IContentContext>({});
export const NavLinkLayoutContext = createContext<INavLinkContext>({});
export const PanelLayoutContext = createContext<IPanelContext>({});
